export default __webpack_public_path__ + "static/img_13-9e2e0ac026704d145028875a6b15eeb7.png";